import moment from 'moment';
import getAirportsAreSame from 'state/checkoutPage/flights/transforms/getAirportsAreSame';

export default function formatFlightsDataForFlightsDetails(flightsData, airportNamesMap, carrierNamesMap) {
  if (!flightsData) {
    return null;
  }

  const { legs } = flightsData;

  const { arrivalAndDepartureAirportAreNotTheSame, initialAndLastAirportAreNotTheSame } = getAirportsAreSame(legs);

  const segmentToSegmentForFlightsDetailsCallback = getSegmentToSegmentForFlightsDetailsCallback(
    airportNamesMap,
    carrierNamesMap
  );

  return legs.map(({ segments, travelTime, nonstop, isOvernight }, index, array) => {
    const isLastLeg = array.length - 1 === index;
    const travelTimeDuration = moment.duration(travelTime, 'minutes');
    const travelDurationHours = travelTimeDuration.hours() + travelTimeDuration.days() * 24;
    const segmentsWithLayovers = insertLayoverBetweenSegments(segments, nonstop);
    const formattedSegments = segmentsWithLayovers.map(segmentToSegmentForFlightsDetailsCallback);

    return {
      departureDate: moment(segments[0].departureTime.slice(0, -6)).format('DD MMMM YYYY'),
      travelTime: `${travelDurationHours}h ${travelTimeDuration.minutes()}m`,
      segments: formattedSegments,
      nonstop,
      arrivalAndDepartureAirportAreNotTheSame: isLastLeg && arrivalAndDepartureAirportAreNotTheSame,
      initialAndLastAirportAreNotTheSame: isLastLeg && initialAndLastAirportAreNotTheSame,
      isOvernight: isOvernight,
    };
  });
}

function getSegmentToSegmentForFlightsDetailsCallback(airportNamesMap, carrierNamesMap) {
  return function segmentToSegmentForFlightsDetailsCallback(segment) {
    const {
      departureTime,
      departureAirport,
      arrivalTime,
      destinationAirport,
      flightTime,
      carrier,
      operatingCarrier,
      flightNumber,
      operatingFlightNumber,
      includedServices,
      layoverTime,
    } = segment;
    if (layoverTime) {
      return segment;
    }
    const flightTimeDuration = moment.duration(flightTime, 'minutes');
    const hasOperatingCarrier = operatingFlightNumber !== flightNumber || operatingCarrier !== carrier;

    return {
      departureTime: moment(departureTime.slice(0, -6)).format('HH:mm'),
      departureAirport,
      departureAirportName: airportNamesMap[departureAirport],
      arrivalTime: moment(arrivalTime.slice(0, -6)).format('HH:mm'),
      destinationAirport,
      destinationAirportName: airportNamesMap[destinationAirport],
      flightTime: `${flightTimeDuration.hours()}h ${flightTimeDuration.minutes()}m`,
      carrierCode: carrier,
      carrierName: carrierNamesMap[carrier],
      carrierLogo: `https://carrierlogos.tripx.eu/${carrier}.png?w=32`,
      flightNumber,
      operatingCarrierCode: hasOperatingCarrier && operatingCarrier,
      operatingCarrierName: hasOperatingCarrier && carrierNamesMap[operatingCarrier],
      operatingCarrierLogo: hasOperatingCarrier && `https://carrierlogos.tripx.eu/${operatingCarrier}.png?w=32`,
      operatingFlightNumber: hasOperatingCarrier && operatingFlightNumber,
      includedServices,
    };
  };
}

function insertLayoverBetweenSegments(segments, nonstop) {
  if (nonstop) {
    return segments;
  }
  const segmentsList = [];

  segments.forEach((segment, index, array) => {
    const nextSegment = array[index + 1];
    if (!nextSegment) {
      segmentsList.push(segment);
      return;
    }
    const layoverTimeDuration = moment.duration(moment(nextSegment.departureTime).diff(moment(segment.arrivalTime)));
    const layoverTime = `${layoverTimeDuration.hours()}h ${layoverTimeDuration.minutes()}m`;
    segmentsList.push(segment);
    if (layoverTimeDuration) {
      segmentsList.push({ layoverTime });
    }
  });
  return segmentsList;
}
